import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import GaugeChart, { GaugeData } from "./GaugeChart";

interface MaturityIndicatorProps {
  data: GaugeData;
  onClick?: () => void;
}

const MaturityIndicator: React.FC<MaturityIndicatorProps> = ({ data, onClick }) => {
  return (
    <Card elevation={3} onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default' }}>
      <CardHeader
        title={
          <Typography variant="h6" align="center">
            {data.name}
          </Typography>
        }
        sx={{ px: 0 }}
      />
      <CardContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 150,
          pt: 0,
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 250 }}>
          <GaugeChart value={data.value} />
        </Box>
      </CardContent>
    </Card>

  )
}

export default MaturityIndicator;
